export default "__VITE_ASSET__DDz8pn7W__"